module.exports = __webpack_public_path__ + "static/media/github.77870f48.svg";